
export default [
    {
        name: 'Liu Bei',
        country: 'Shu',
        health: 4,
        gender: 'M',
        isMonarch: true,
    },
    {
        name: 'Guan Yu',
        country: 'Shu',
        health: 4,
        gender: 'M',
    },
    {
        name: 'Zhang Fei',
        country: 'Shu',
        health: 4,
        gender: 'M',
    },
    {
        name: 'Zhuge Liang',
        country: 'Shu',
        health: 3,
        gender: 'M',
    },
    {
        name: 'Zhao Yun',
        country: 'Shu',
        health: 4,
        gender: 'M',
    },
    {
        name: 'Ma Chao',
        country: 'Shu',
        health: 4,
        gender: 'M',
    },
    {
        name: 'Huang Yue Ying',
        country: 'Shu',
        health: 3,
        gender: 'F',
    },
    {
        name: 'Sun Quan',
        country: 'Wu',
        health: 4,
        gender: 'M',
        isMonarch: true,
    },
    {
        name: 'Gan Ning',
        country: 'Wu',
        health: 4,
        gender: 'M',
    },
    {
        name: 'Lu Meng',
        country: 'Wu',
        health: 4,
        gender: 'M',
    },
    {
        name: 'Huang Gai',
        country: 'Wu',
        health: 4,
        gender: 'M',
    },
    {
        name: 'Zhou Yu',
        country: 'Wu',
        health: 3,
        gender: 'M',
    },
    {
        name: 'Da Qiao',
        country: 'Wu',
        health: 3,
        gender: 'F',
    },
    {
        name: 'Lu Xun',
        country: 'Wu',
        health: 3,
        gender: 'M',
    },
    {
        name: 'Sun Shang Xiang',
        country: 'Wu',
        health: 3,
        gender: 'F',
    },
    {
        name: 'Cao Cao',
        country: 'Wei',
        health: 4,
        gender: 'M',
        isMonarch: true,
    },
    {
        name: 'Sima Yi',
        country: 'Wei',
        health: 3,
        gender: 'M',
    },
    {
        name: 'Xiahou Dun',
        country: 'Wei',
        health: 4,
        gender: 'M',
    },
    {
        name: 'Zhang Liao',
        country: 'Wei',
        health: 4,
        gender: 'M',
    },
    {
        name: 'Xu Chu',
        country: 'Wei',
        health: 4,
        gender: 'M',
    },
    {
        name: 'Guo Jia',
        country: 'Wei',
        health: 3,
        gender: 'M',
    },
    {
        name: 'Zhen Ji',
        country: 'Wei',
        health: 3,
        gender: 'F',
    },
    {
        name: 'Hua Tuo',
        country: 'Kingdomless',
        health: 3,
        gender: 'M',
    },
    {
        name: 'Diao Chan',
        country: 'Kingdomless',
        health: 3,
        gender: 'F',
    },
    {
        name: 'Lu Bu',
        country: 'Kingdomless',
        health: 5,
        gender: 'M',
    },
    {
        name: 'Wei Yan',
        country: 'Shu',
        health: 4,
        gender: 'M',
        expansion: 'wind',
    },
    {
        name: 'Huang Zhong',
        country: 'Shu',
        health: 4,
        gender: 'M',
        expansion: 'wind',
    },
    {
        name: 'Xiahou Yuan',
        country: 'Wei',
        health: 4,
        gender: 'M',
        expansion: 'wind',
    },
    {
        name: 'Cao Ren',
        country: 'Wei',
        health: 4,
        gender: 'M',
        expansion: 'wind',
    },
    {
        name: 'Zhou Tai',
        country: 'Wu',
        health: 4,
        gender: 'M',
        expansion: 'wind',
    },
    {
        name: 'Xiao Qiao',
        country: 'Wu',
        health: 3,
        gender: 'F',
        expansion: 'wind',
    },
    {
        name: 'Zhang Jiao',
        country: 'Kingdomless',
        health: 3,
        gender: 'M',
        expansion: 'wind',
        isMonarch: true,
    },
    {
        name: 'Yu Ji',
        country: 'Kingdomless',
        health: 3,
        gender: 'M',
        expansion: 'wind',
    },
    {
        name: 'Zhuge Liang 8',
        country: 'Shu',
        health: 3,
        gender: 'M',
        expansion: 'fire',
    },
    {
        name: 'Pang Tong',
        country: 'Shu',
        health: 3,
        gender: 'M',
        expansion: 'fire',
    },
    {
        name: 'Dian Wei',
        country: 'Wei',
        health: 4,
        gender: 'M',
        expansion: 'fire',
    },
    {
        name: 'Xun Yu',
        country: 'Wei',
        health: 3,
        gender: 'M',
        expansion: 'fire',
    },
    {
        name: 'Tai Shi Ci',
        country: 'Wu',
        health: 4,
        gender: 'M',
        expansion: 'fire',
    },
    {
        name: 'Yuan Shao',
        country: 'Kingdomless',
        health: 4,
        gender: 'M',
        expansion: 'fire',
        isMonarch: true,
    },
    {
        name: 'Pang De',
        country: 'Kingdomless',
        health: 4,
        gender: 'M',
        expansion: 'fire',
    },
    {
        name: 'Yan Liang Wen Chou',
        country: 'Kingdomless',
        health: 4,
        gender: 'M',
        expansion: 'fire',
    },
    {
        name: 'Meng Huo',
        country: 'Shu',
        health: 4,
        gender: 'M',
        expansion: 'wood',
    },
    {
        name: 'Zhu Rong',
        country: 'Shu',
        health: 4,
        gender: 'F',
        expansion: 'wood',
    },
    {
        name: 'Xu Huang',
        country: 'Wei',
        health: 4,
        gender: 'M',
        expansion: 'wood',
    },
    {
        name: 'Cao Pi',
        country: 'Wei',
        health: 3,
        gender: 'M',
        expansion: 'wood',
        isMonarch: true,
    },
    {
        name: 'Sun Jian',
        country: 'Wu',
        health: 4,
        gender: 'M',
        expansion: 'wood',
    },
    {
        name: 'Lu Su',
        country: 'Wu',
        health: 3,
        gender: 'M',
        expansion: 'wood',
    },
    {
        name: 'Dong Zhuo',
        country: 'Kingdomless',
        health: 8,
        gender: 'M',
        expansion: 'wood',
        isMonarch: true,
    },
    {
        name: 'Jia Xu',
        country: 'Kingdomless',
        health: 3,
        gender: 'M',
        expansion: 'wood',
    },
    {
        name: 'Xun You',
        country: 'Wei',
        health: 3,
        gender: 'M',
        expansion: 'Knight12',
    },
    {
        name: 'Cao Zhang',
        country: 'Wei',
        health: 4,
        gender: 'M',
        expansion: 'Knight12',
    },
    {
        name: 'Wang Yi',
        country: 'Wei',
        health: 4,
        gender: 'F',
        expansion: 'knight12',
    },
    {
        name: 'Zhong Hui',
        country: 'Wei',
        health: 4,
        gender: 'M',
        expansion: 'knight12',
    },
    {
        name: 'Ma Dai',
        country: 'Shu',
        health: 4,
        gender: 'M',
        expansion: 'knight12',
    },
    {
        name: 'Liao Hua',
        country: 'Shu',
        health: 4,
        gender: 'M',
        expansion: 'knight12',
    },
    {
        name: 'Guan Xing Zhang Bao',
        country: 'Shu',
        health: 4,
        gender: 'M',
        expansion: 'knight12',
    },
    {
        name: 'Bu Lian Shi',
        country: 'Wu',
        health: 3,
        gender: 'F',
        expansion: 'knight12',
    },
    {
        name: 'Han Dang',
        country: 'Wu',
        health: 4,
        gender: 'M',
        expansion: 'knight12',
    },
    {
        name: 'Cheng Pu',
        country: 'Wu',
        health: 4,
        gender: 'M',
        expansion: 'knight12',
    },
    {
        name: 'Hua Xiong',
        country: 'Kingdomless',
        health: 6,
        gender: 'M',
        expansion: 'knight12',
    },
    {
        name: 'Liu Biao',
        country: 'Kingdomless',
        health: 4,
        gender: 'M',
        expansion: 'knight12',
    },
    {
        name: 'Yang Xiu',
        country: 'Wei',
        health: 3,
        gender: 'M',
        expansion: 'sp11',
    },
    {
        name: 'Gongsun Zan',
        country: 'Kingdomless',
        health: 4,
        gender: 'M',
        expansion: 'sp11',
    },
    {
        name: 'Yuan Shu',
        country: 'Kingdomless',
        health: 4,
        gender: 'M',
        expansion: 'sp11',
    },
    {
        name: 'Cai Wen Ji',
        country: 'Kingdomless',
        health: 3,
        gender: 'F',
        expansion: 'sp11',
    },
    {
        name: 'Liu Shan',
        country: 'Shu',
        health: 3,
        gender: 'M',
        expansion: 'hill',
        isMonarch: true,
    },
    {
        name: 'Jiang Wei',
        country: 'Shu',
        health: 4,
        gender: 'M',
        expansion: 'hill',
    },
    {
        name: 'Deng Ai',
        country: 'Wei',
        health: 4,
        gender: 'M',
        expansion: 'hill',
    },
    {
        name: 'Zhang He',
        country: 'Wei',
        health: 4,
        gender: 'M',
        expansion: 'hill',
    },
    {
        name: 'Zhang Zhao Zhang Hong',
        country: 'Wu',
        health: 3,
        gender: 'M',
        expansion: 'hill',
    },
    {
        name: 'Sun Ce',
        country: 'Wu',
        health: 4,
        gender: 'M',
        expansion: 'hill',
        isMonarch: true,
    },
    {
        name: 'Fa Zheng',
        country: 'Shu',
        health: 3,
        gender: 'M',
        expansion: 'knight11',
    },
    {
        name: 'Ma Su',
        country: 'Shu',
        health: 3,
        gender: 'M',
        expansion: 'knight11',
    },
    {
        name: 'Xu Shu',
        country: 'Shu',
        health: 3,
        gender: 'M',
        expansion: 'knight11',
    },
    {
        name: 'Cao Zhi',
        country: 'Wei',
        health: 3,
        gender: 'M',
        expansion: 'knight11',
    },
    {
        name: 'Yu Jin',
        country: 'Wei',
        health: 4,
        gender: 'M',
        expansion: 'knight11',
    },
    {
        name: 'Zhang Chun Hua',
        country: 'Wei',
        health: 3,
        gender: 'F',
        expansion: 'knight11',
    },
    {
        name: 'Wu Guo Tai',
        country: 'Wu',
        health: 3,
        gender: 'F',
        expansion: 'knight11',
    },
    {
        name: 'Xu Sheng',
        country: 'Wu',
        health: 4,
        gender: 'M',
        expansion: 'knight11',
    },
    {
        name: 'Ling Tong',
        country: 'Wu',
        health: 4,
        gender: 'M',
        expansion: 'knight11',
    },
    {
        name: 'Chen Gong',
        country: 'Kingdomless',
        health: 3,
        gender: 'M',
        expansion: 'knight11',
    },
    {
        name: 'Gao Shun',
        country: 'Kingdomless',
        health: 4,
        gender: 'M',
        expansion: 'knight11',
    },
    {
        name: 'Liu Xie',
        country: 'Kingdomless',
        health: 3,
        gender: 'M',
        expansion: 'sp11',
    },
    {
        name: 'Sha Mo Ke',
        country: 'Shu',
        health: 4,
        gender: 'M',
        expansion: 'sp11',
    },
    {
        name: 'Yue Jin',
        country: 'Wei',
        health: 4,
        gender: 'M',
        expansion: 'sp11',
    },
    {
        name: 'Sun Hao',
        country: 'Wu',
        health: 5,
        gender: 'M',
        expansion: 'sp11',
        isMonarch: true,
    },
];
